import Image from 'next/image';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import arrowBottom from '@/public/icons/collection/arrow-bottom.svg';
import { scrollToTop } from './helpers';

const useHideArrow = (
  height: number,
  setIsVisible: (isVisible: boolean) => void,
) => {
  const listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    const shouldBeVisible = winScroll > height;

    setIsVisible(shouldBeVisible);
  };

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);

    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);
};

export default function BackToTopButton() {
  // Hide arrow when scroll to certain height
  const [isVisible, setIsVisible] = useState(false);

  useHideArrow(300, setIsVisible);

  return (
    <div
      id="scrollToTop"
      className={cn(
        'fixed bottom-[170px] right-5 z-[70] flex rotate-180 items-center justify-center bg-gray-700 p-3 opacity-80 hover:cursor-pointer sm:opacity-100 md:p-4',
        { flex: isVisible, hidden: !isVisible },
      )}
      onClick={scrollToTop}
    >
      <Image src={arrowBottom} alt="collapse" loading="lazy" />
    </div>
  );
}
